<div class="row">
  <div class="col-2 ps-0 sidebar">
    <app-sidebar [items]="menuItems" [current]="currentContent"></app-sidebar>
  </div>
  <div class="col-10 px-0">
    <div class="card">
      <h4 class="card-header">404 Not Found</h4>
      <div class="card-body">
        <p>
          <img class="rounded-sm" src="assets/rolling_hay.gif" alt="404 Not Found">
        </p>
        <p>The page you requested was not found.</p>
      </div>
    </div>
  </div>
</div>